// components/ContactHeader/ContactHeader.jsx
import React from 'react';
import { Phone, Mail } from 'lucide-react';

const ContactHeader = ({ email, phone }) => {
  return (
    <div className="text-center mb-10 sm:mb-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
      <div className="mx-auto w-fit space-y-4 sm:space-y-0 sm:flex items-center justify-center gap-6 mt-6">
        <div className="flex items-center gap-2">
          <Phone className="w-5 h-5 text-red-600" />
          <a href={`tel:+91${phone}`}
          title="Call for Enquiries And Admissions"
          className="text-gray-600 font-medium hover:text-black duration-150 ease-in-out">
            {phone}
          </a>
        </div>
        <div className="flex items-center gap-2">
          <Mail className="w-5 h-5 text-red-600" />
          <a href={`mailto:${email}`} className="text-gray-600 hover:text-blue-600 font-medium">
            {email}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactHeader;